import { render, staticRenderFns } from "./VideoGen.vue?vue&type=template&id=47a4b5e1&scoped=true&"
import script from "./VideoGen.vue?vue&type=script&lang=js&"
export * from "./VideoGen.vue?vue&type=script&lang=js&"
import style0 from "./VideoGen.vue?vue&type=style&index=0&id=47a4b5e1&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a4b5e1",
  null
  
)

export default component.exports